export default {
  search: "搜索",
  clear: "清空条件",
  close: "关闭",
  clear_:'清空',
  search_result:'搜索结果',
  no_result: "暂无结果",
  load_more: '加载更多',
  required: "必填项",
  optional: "选填项",
  detail: "详情",
  change_password: "修改密码",
  forget_pwd: "忘记密码",
  set_pwd: "设置密码",
  sku_detail: "产品详情",
  verification_of_phone: "手机验证",
  verification_of_email: "邮箱验证",
  error: "错误",
  next: "下一步",
  training:"新用户引导",
  training_new:"新手引导",
  training_old:"新功能引导",
  "产品库": '产品推送查看',
  attend_sport: '扫一扫参加运动会',
  PAL: "产品资讯库",
  check_all: "全选",
  deselect_all:"取消全选",
  preferences: "偏好设置",
  event_tag: "管理标签",
  interest_tag:"用户兴趣标签",
  gender: "性别",
  division: "分类",
  category: "品类",
  finish:"完成",
  planning_intended_use: "PLANNING INTENDED USE",
  content_of_interest: "感兴趣的内容",
  description:"描述",
  autoClose: "{seconds}秒后自动关闭",
  keep_open: "暂不关闭",
  training_description:{
    "page1": "个人中心",
    "page2": "维护个人信息",
    "page3": "保存个人信息",
    "page4": "首页广场配有公告，运动赛事",
    "page5": "公告",
    "page6": "公告详情",
    "page7": "运动赛事",
    "page8": "手机扫码报名运动项目",
    "page9": "eMoment 小助手入口",
    "page10": "eMoment 操作手册，新功能介绍视频，常见问题",
    "page11": "进入操作手册",
    "page12": "操作手册",
    "page13": "进入新功能介绍视频",
    "page14": "新功能介绍视频",
    "page15": "进入常见问题",
    "page16": "常见问题",
    "page17": "关闭小助手",
    "page18": "进入活动",
    "page19": "会议列表",
    "page20": "会议类型为 LIVE ，且右下角展示绿点，表示直播会议正在进行",
    "page21": "会议工具，包括 VSS ，聊天室，书签，产品推送查等",
    "page22": "返回会议列表",
    "page23": "会议类型为 ZOOM ，且右下角展示绿点，表示互动会议正在进行",
    "page24": "点击进入 ZOOM",
    "page25": "返回会议列表",
    "page26": "会议类型为 PLAYBACK ，且按钮为播放状态，表示重播会议可以观看",
    "page27": "会议包括 VSS ，书签，产品推送查，清晰度，音量，倍速等",
    "page28": "返回会议列表",
    "page29": "活动广场配有预热资产， VSS 搜索",
    "page30": "预热资产",
    "page31": "活动预热图片和视频展示",
    "page32": "智能视频搜索",
    "page33": "输入内容，选择会议，点击搜索",
    "page34": "搜索结果展示",
    "page35": "产品资讯库入口",
    "page36": "PAL 分为首页和成套搭配",
    "page37": "搜索，筛选产品",
    "page38": "查看产品详情",
    "page39": "产品详情",
    "page40": "收藏产品",
    "page41": "收藏产品至收藏夹",
    "page42": "选择收藏夹",
    "page43": "记录产品笔记",
    "page44": "记录并提交",
    "page45": "笔记列表",
    "page46": "笔记导出",
    "page47": "返回公告，查看笔记导出文件",
    "page48": "成套搭配",
    "page49": "买货推荐分类",
    "page50": "查看成套搭配",
    "page51": "左右切换查看成套搭配",
    "page52": "切换产品详情",
    "page53": "查看产品详情"
  },
  preferences_setting:{
    MENS: "男子",
    WOMENS: "女子",
    KIDS: "儿童",
    FOOTWEAR:"鞋子",
    APPAREL: "服饰",
    EQUIPMENT: "配件",
    PERFORMANCE: "PERFORMANCE",
    LIFESTYLE: "LIFESTYLE",
    JORDAN: "JORDAN",
    tips: "请至少选择1个感兴趣的内容",
    err_message: "请至少选择一个",
    OTHERS:"OTHERS",
    tip_err_1:"至少选择一个感兴趣的性别",
    tip_err_2:"至少选择一个感兴趣的分类",
    tip_err_3:"至少选择一个感兴趣的PLANNING INTENDED USE",
  },
  application: {
    "产品库": '产品推送查看',
  },
  'Q&A': 'Q&A',
  "forecast_of_assets": "预热资产",
  chatroom: '聊天室',
  sports_events: "运动赛事",
  announcement_board: "公告栏",
  floor: "楼",
  loading: "加载中",
  announcement_type: {
    in_station: "系统公告",
    active: "活动公告",
    session: "会议公告",
    sport: "运动公告",
    activity: "项目公告"
  },
  score:{
    score:'积分',
    score_detail:'积分明细',
    score_rules:'积分规则',
    sign_in:'签到',
    signed:'已签到'
  },
  VSS:"VSS搜索",
  step:"步骤",
  vss:{
    input_video_tag:'输入视频标签',
    select_session:'选择会议',
    new_feature:'新功能提醒',
    tip1:'步骤一',
    tip2:'步骤二',
    description1:'广场新增Video Smart Search功能。',
    description2:'可根据视频标签和会议进行搜索,请选择标签、会议进行搜索。标签是可输入的，键入后回车确认为标签。',
    description3:'搜索结果高亮展示，点击结果将跳转页面。',
    warning1:'请选择会议',
    warning2:'请选择会议并搜索',
    warning3:'请选择标签',
    },
  nextBtnText: "下一步",
  prevBtnText: "上一步",
  doneBtnText: "完成引导",
  closeBtnText: "跳过引导",
  select_all:'全选',
  cancel_select:'取消全选',
  score_item_map:{
    "0":"签到",
    "1":"楼、会议室签到",
    "2":"观看直播",
    "3":"预览、重播",
    "4":"聊天室互动",
    "5":"书签",
    "6":"查看推送产品",
    "7":"点赞",
    "8":"使用笔记",
    "9":"收藏",
    "10":"运动会签到",
  },
  time: '时间',
  //错误提醒
  errMsg: {
    "validation error": "验证码错误!",
    email_no_match_phone: "邮箱与手机号不匹配!",
    phone_no_match_email: "手机号与邮箱不匹配!",
    register_confirm_privacy: "如需注册活动，请您查看并同意耐克的隐私政策。",
    user_not_exist: "用户不存在",
    login_confirm_privacy: "如需登录系统，请您查看并同意耐克的隐私政策。",
    "password error": "密码错误",
    "BAD PASSWORD FORMAT": "密码格式不对。",
    "TWO DIFFERENT PASSWORDS": "两次密码不一致。",
    "NAME IS REQUIRED": "姓名为必填项。",
    "PASSWORD IS REQUIRED": "密码为必填项。",
    "PHONE NUMBER AND EMAIL CAN'T BE EMPTY AT THE SAME TIME": "手机号与邮箱不能同时为空。",
    "ACCOUNT GROUP IS REQUIRED": "客户组为必选项。",
    "GENDER IS REQUIRED": "性别为必选项。",
    "CHOOSE ONE OF ONLINE AND ONSITE AT LEAST.": "请在线上/现场这两种参会方式中，至少选择一项。",
    OKTA_Login_Fail: "OKTA登录失败，请点击\"耐克内部员工登录\"尝试再次登录。",
    "MSG CANNOT BE EMPTY": "不能发送空消息。",
    "QUESTION CANNOT BE EMPTY": "问题不能为空。",
    "PROBLEM FEEDBACK FAILED": "问题反馈失败。",
    "notice expired": "公告已过期。",
    "you have no permission": "您无权登录系统。",
    "no_phone": "手机号不能为空!",
    "no_email": "邮箱不能为空!",
    "no_company": "公司不能为空!",
    "incorrect email format": "邮箱格式不正确。",
    "no_validation_code": "验证码不能为空。",
    "same_phone": "新的手机号与旧的手机号相同，无需更新。",
    "phone number existed": "手机号已经存在，请使用其他手机号。",
    "email existed": "邮箱已经存在，请使用其他邮箱。",
    "no_username": "用户名不能为空。",
    "same_email": "新旧邮箱不能相同。",
    "wrong validation code, please check it again.": "验证码错误，请重新检查您的验证码。",
    "invitation code is expired or reach allowed max user": "邀请码过期或邀请人数已达上限。",
    "invitation code is reach allowed max user": "邀请码的邀请人数已达上限。",
    "owner has completed request, not allow approve item again": "活动管理员已经完成审核，您无法再审核该申请。",
    "no attendee need to approve": "暂无需要审核的参会人。",
    "unable find invitation code": "无效邀请连接。",
    "invitation code is expired": "邀请链接已过期。",
    "request in progress": "您的申请在审批中",
    "request approved in this event": "您的申请已经通过",
    "login fail": "登录失败",
    "user blocked": "您的账号已被停用。",
    "the image you uploaded is not in the right format": "您上传的图片格式不对, 图片仅支持:jpg、png、jpeg格式!",
    "PHONE NUMBER AND EMAIL REQUIRED": "手机号与邮箱均为必填项。",
    "user have no email": "您没有邮箱，请先维护邮箱。",
    "no access to login system": "您暂无权限登录系统。",
    "some bookmark not save": "有未保存的内容！",
    'you have already approved to join this event, no need to request': '您已加入该活动中，不需要重复注册',
    "no users ro no sessions in this invitation": "此邀请中没有参会人或没有维护会议",
    "no chat history": "没有历史信息",
    "you are not authorized as an broadcaster": "您暂无播音员权限",
    "chat message send error": "消息发送失败，请稍后重试",
  },
  //成功提醒
  successMsg: {
    "copy successfully": "复制成功。",
    change_password_success: "修改密码成功!",
    password_reset_succeeded: "重置密码成功!",
    "send_email_validation_same_time": "如您无法收到短信验证码，系统已经同时将验证码发送到您注册时填写的邮箱中，请到收件箱中查看验证码。",
    "send_email_validation_success": "验证码已发送到您的邮箱, 请注意查收!",
    "send_phone_validation_success": "验证码已发送到您的手机, 请注意查收!",
    "the_reservation_email_has_been_sent": "预约邮件已发送!",
  },
  //提示信息
  confirmMsg: {
    "confirm delete bookmark": "确认删除书签？",
    no_event: '您目前暂无活动。',
    no_other_event: "您目前暂无其他活动",
    no_session: '您目前暂无会议。',
    no_notice: "暂无公告",
    preparatory_phase: "该活动正处于准备阶段！",
    event_not_start: "活动暂未开启，请等待!"
  },
  // 警告提示
  warningMsg:{
    'no_wonderful_moment_content': '暂无精彩瞬间 ~'
  },

  preview: "预览",
  notice: "公告",
  view_detail: "查看详情",
  notice_detail: {
    all: "全部",
    in_station: "站内",
    active: "活动",
    session: "会议",
    sport: "运动",
    activity:"项目",
    unread: "未读",
    all_read: "全部已读",
    view: "查看",
    accessory: "附件",
    accessory_name: "附件名称",
    notice_name: "公告名称",
    download_accessory: "下载附件",
    new_notice: "新增公告"
  },
  broadcast: {
    start_at: "直播将于{start_time}开始",
    start: "直播开始",
    thanks_for_watching: "感谢观看直播！",
    start_time: "开始时间：{start_time}",
    will_go: "<span class='second'>{seconds}</span>秒后将为您自动跳转至下一场会议",
    stop_go_btn: "暂不跳转",
  },

  app: {
    broswer: "浏览器不支持！",
    broswer0: "当前浏览器兼容性差，请使用 ",
    broswer1: "Chrome 浏览器",
  },

  login: {
    phone_number: "手机号",
    enter_phone_number: "请输入手机号",
    enter_email_number: "请输入邮箱",
    send_validation_code: "获取验证码",
    enter_validation_code: "请输入验证码",
    count_down_validation: "{second}秒后可以重试",
    login: "登录",
    register: "注册",
    privacy: "我同意耐克的<a class='privacy_link' style='{style}' href='/Privacy' target='_blank'>隐私政策</a>",
    language: "语言选择",
    nike_login: "耐克内部员工登录",
    nike_register: "耐克内部员工注册",
    back_login: "返回登录",
    pwd_tip: "如未收到验证码，请联系emoment.service@nike.com",
    new_pwd: "请输入新密码",
    confirm_new_pwd: "请确认新密码"
  },

  no_resources: "暂无资源",

  register: {
    division: "分类",
    category: "品类",
    gender: "性别",
    tag1: "TAG",
    tag2: "品类",
    tag3: "性别",
    tag4: "TAG4",
    tag5: "TAG5",
    user_tag: 'TAG',
    confirm_user_information: "确认用户信息",
    name: "姓名",
    gender: "性别",
    select_gender: "请选择性别",
    male: "男",
    female: "女",
    phone: "手机号",
    old_phone: "原手机号",
    new_phone: "新手机号",
    password: "登录密码",
    confirm_password: "确认密码",
    old_password: "请输入旧密码",
    new_password: "请输入新密码",
    pwd_placeholder: "密码必须包含大小写字母和数字且不少于8位",
    old_email: "原邮箱",
    new_email: "新邮箱",
    validation_code: "验证码",
    get_validataion_code: "获取验证码",
    change: "更改",
    email: "邮箱",
    upload_avatar: "上传头像",
    account_group: "客户组",
    select_account_group: "请选择客户组",
    area: "区域",
    city: "城市",
    company: "公司",
    online: "线上",
    onsite: "现场",
    online_onsite_description: "该选项支持多选。但请根据您的情况，选择参会的方式。",
    language: "语言",
    select_language: "请选择语言",
    register: "注册",
    privacy: "我同意耐克的<a class='privacy_link' href='/Privacy' target='_blank'>隐私政策</a>",
    reg_pending_name: "亲爱的{user_name}，",
    reg_pending: "您已申请参加【{event_name}】，请等待客户联络员/活动管理员批准。",
    input_name: "姓名",
    input_phone: "手机号码",
    input_email: "邮箱",
    select_company: "选择公司",
    input_location: "输入地区",
    input_city: "输入城市",
    select_divistion: "选择分类",
    select_category: "选择品类",
    select_tag_gender: "选择性别",
    warning: "注意",
    retry_warning: "系统检测到您已经发送了多次手机验证码。如您任然无法收到验证码，请将您的姓名，手机号，电话前缀 (+86, +886, +852, +853) 与邮箱地址通过邮件发送给我们 (邮件地址：<a href='mailto:eMoment.Service@nike.com'>eMoment.Service@nike.com</a>)。系统将会帮您创建账号并通知您。请您在收到通知后，重新尝试注册登录系统。",
  },

  update_me: {
    get_code: "获取验证码",
    count_down: "{second}秒后重试",
  },

  litter_helper: {
    eMoment_litter_helper: "eMoment小助手",
    user_manual: "用户使用手册",
    feature_description_video: "功能介绍视频",
    FAQ: "常见问题",
    catalog: "目录",
    clear_the_history: "清空历史记录",
    history: "历史记录",
    search_placeholder: "请输入关键词搜索",
    no_content: "暂无内容",
    no_search: "抱歉, 没有找到结果。请换个关键词试试~",
    preparatory_phase: "准备阶段",
    registration_phase: "注册阶段",
    activity_phase: "活动阶段",
    activity_end: "活动结束",
    solve_problem: "是否解决了你的问题 ?",
    solve_problem_ok: "是，已解决",
    solve_problem_no: "否， 为解决",
    feedback: "感谢您的反馈！",
    send_email: "请将您的问题编辑后发送至",
    i_know: "我知道了",
    system_admin: "系统管理员",
    event_admin: "活动管理员",
    attendee: "参会人",
    broadcaster: "播音员",
    partner_contactor: "客户联络员",
    speaker: "讲者",
    assistant: "产品专家",
    general: "通用",
    close_inquiry: "{count}s 后关闭",
    faq_feedback: "问题反馈",
    enter_question: "请输入问题",
    successful_problem_feedback: "问题反馈成功"
  },

  activity: {
    no_content: "暂无活动介绍",
  },

  privacy: "隐私政策",
  system_admin: "系统设置",
  session: {
    样品库: "推送产品查",
    get_obs: "获取OBS软件",
    obs_studio: "OBS直播软件",
    vlc_playper: "VLC播放器",
    obs_studio_subtitle: "OBS直播软件字幕插件",
    download: "下载",
    get_obs_start: "获取当前频道的推流配置",
    current_channel: "当前频道",
    broadcast_date: "开播日期：",
    broadcast_time: "开播时间：",
    broadcast_start: "是否开播",
    join_in_chat_room: "加入该聊天室",
    back_to_event: "返回活动详情",
    back_to_role_select: "返回角色选择",
    month: "月",
    day: "天",
    hour: "小时",
    minute: "分钟",
    second: "秒",
    chat_in_room: "聊天室：{session_name}",
    input_chat_msg: "请输入聊天内容",
    chat_room: "聊天室",
    session_name: "会议名称",
    session_time: "会议时间",
    session_type: "会议类型",
    session_date: "会议日期",
    session_room_name: "会议室名称",
    session_place: '参会地点',
    session_room: '会议室',
    session_detail: "会议详情",
    activity_introduction: "活动介绍",
    activity_session: "活动会议 (线下)",
    estimated_video_duration: "视频预估时长",
    video_duration: "视频时长",
    speaker: "会议讲者",
    session_description: "会议描述",
    video_time: "会议时长",
    send: "发送",
    home: "活动列表",
    logout: "登出",
    save: "保存",
    cancel: "取消",
    notice: "注意",
    no_event: "您目前暂无活动。",
    no_session: "您目前暂无会议。",
    player_error: "直播出现了问题，请稍候刷新页面，如依然出现此问题，请联系管理员。",
    liveStreamStop: "当前会议已经结束",
    chapter: '章节',
    bookmark: '书签',
    bookmark_input: '请输入内容',
    no_bookmark: '暂无书签',
    window_title: '窗口',
    chatroom: '聊天室',
    attendee_list: '参会人列表',
    online: '在线',
    offline: '离线',
    select: '请选择',
    to_all: '全体',
    delete_message: '确认删除这条消息？',
    status: '状态',
    block: '禁言',
    block_reason: '禁言理由:',
    send_to_you: '私聊我',
    you_send_to: '我私聊',
    say: '说',
    blocking: '禁言中',
    block_count_down: '禁言倒计时：',
    someone_send_me: '有人私聊我。',
    download_chat: '下载聊天记录',
    download_after_session: '会议结束后下载聊天记录',
    send_to: '发给',
    okText: '确认',
    cancelText: '取消',
    bookmark_tip: "书签简介：点击输入框，记录观看笔记。",
    caption_tip: "字幕：点击按钮，字幕开启。",
    thumbsUp_tip: "点击与线上参会人互动",
    QA: {
      enter_QA: '进入Q&A',
      preTitle: 'BRA/LEGGING 讲解',
      is_mine: '仅显示我的问题',
      all_qa: '全部QA',
      show_all_question: '显示所有问题',
      un_answer: '未回答',
      answered: '已回答',
      closed: '已关闭',
      my_question: '我的问题',
      all_question: '所有问题',
      search_question: '搜索问题',
      is_public: '是否公开',
      input_notify: '输入我的问题...',
      text1: '欢迎来到问答',
      text2: '您提出的问题将会显示在此处。',
      text3: "除私信发送外，您发送的问题将展示在'所有问题'列表。",
      confirmDel: '确定删除问题？',
      confirmDelete: '确认删除？',
      confirmSend: '是否提交？',
      confirmCancel: '是否取消？(取消会删除当前输入)？',
      myReAsk: '我要追问',
      reAsk: '追问',
      answerNotify: '确认回答？',
      myAsk: '我要提问',
      inputAnswer: '输入我的回答...',
      tips: '提示',
      cancelIdentify: '取消确认(取消后输入框内容将不保留)',
      cancel: '取消',
      identify: '确认',
      modifyQAIdentify: '确认修改这条问题?',
      commit: '提交',
      contentNotify: '内容不能为空',
      total: '共',
      total1: '条',
      noSession: '未绑定会议，请联系活动管理员',
      edit: '编辑',
      answer: '回答',
      editQuestion: '编辑问题',
      isPublic: '是否公开',
      del: '删除',
      me: '我',
      assistant: '产品专家',
      last_edit: '上一次编辑有未发送内容,',
      use_last_edit: '使用上一次的编辑',
    }
  },

  video: {
    try_later: "视频转码中，请稍后重试",
  },

  meeting: {
    warning: "提醒",
    agree_user_info: "同意",
    disagree_user_info: "不同意，返回会议列表",
    agree_rule: "用户您好，由于提供在线会议功能所需，您参加在线会议时所显示的名称将提供给ZOOM并传输至境外服务器，请问是否同意？",
  },

  portal: {
    participant: "参会人模块",
    admin: "管理员模块",
    partner_contact: "客户联络员",
    attendee: "参会人",
    assistant: "产品专家",
    broadcaster: "播音员",
    hoster: "ZOOM主持人",
  },
  'CORE': '核心',
  'NONCORE': '非核心',
  approval: {
    not_approved: '审批中...',
    approved_pass: '审批通过',
    approved_refuse: '审批未通过',
    first_approval_pass: '一审已通过',
    first_approval_refuse: '一审未通过',
    second_approved_refuse: '二审未通过',
    first_approval_pass_tip: '一审已通过，请等待二审审批',
    first_approval_refuse_tip: '一审未通过，有疑问请联系客户联络员',
    approved_refuse_tip: '审批未通过，有疑问请联系活动管理员'
  },
  event_detail: {
    approval_list: "审批列表",
    approval_report: "审批报表",
    my_event: "我的其它活动",
    seasonal_video: "当季视频",
    seasonal_image: "当季图片",
    report: {
      pc_approval: "Partner Contact 审批情况",
      register_table: "注册表",
      register_table_approved: "一审已通过",
      register_table_rejected: "一审已拒绝",
      register_table_wait: "一审未操作",
      approve_table: "审批表",
      approve_table_left: "邀请剩余名额",
      ea_approval: "Event Admin 审批情况",
      ea_table_approved: "二审已通过",
      ea_table_rejected: "二审已拒绝",
      ea_table_wait: "二审未操作",
      real_time_login: "实时登录情况",
      real_time_login_description: "从【{time}】开始，5分钟内登录数据。",
      actual_login: "实际登录用户数",
      no_login: "没有登录数",
    },
    channel_list: "频道列表",
    download_approval_list: "下载审批列表",
    upload_approval_list: "上传审批列表",
    online_onsite: "线上/现场",
    online: "线上",
    onsite: "现场",
    registration_status: "注册状态",
    confirmed_status: {
      PENDING: "待审核",
      CONFIRMED: "批准",
      REJECTED: "拒绝",
    },
    approve: "批准",
    reject: "拒绝",
    edit: "编辑",
    invitation_list: "邀请列表",
    expired_time: "邀请过期时间",
    invitation_url: "邀请链接",
  },

  user: {
    phone: "手机",
    email: "邮箱",
    LOCATION: "区域",
    COMPANY: "公司",
    account_group: "客户组",
    CITY: "城市",
    account: "账号",
    password: "密码",
    name: "姓名",
    clear_openid: "清空OPENID",
    disabled: "已停用",
    enabled: "已启用",
    prefix: "区号",
    gender: "性别",
    is_disabled: "账号是否停用",
    is_internal: "内部员工",
    only_internal: "仅显示内部员工",
    without_internal: "不显示内部员工",
    TAG1: "TAG1",
    TAG2: "TAG2",
    TAG3: "TAG3",
    TAG4: "TAG4",
    TAG5: "TAG5",
    is_main_owner: "活动拥有者",
    is_owner: "活动管理员",
    is_partner_contact: "活动联络员",
  },

  play_only_once: "只播放一次",
  no_replay_available: "不提供重播",
  account_group: "客户组",
  action: "操作",
  back: "返回",
  event_name: "活动名称",
  event_range: "活动时间",
  no_support_mobile: "该平台暂时不支持手机浏览，请使用电脑浏览。",
  copy: "复制",
  confirm: "确定",
  "INVITATION URL IS INVALID.": "邀请码无效。",
  "RELOAD TO WATCH BROADCAST.": "直播即将开始，请稍候",
  "RELOAD TO WATCH PLAYBACK.": "重播即将开始，请稍候",
  "BROADCAST IS OVER.": "该场直播已结束<br/>请等待回放或进入下一场直播",
  "PLAYBACK IS OVER.": "该场重播已结束",
  count_down_no_content: "该会议暂无内容，请联系系统/活动管理员",
  // There is no content for this meeting. Please contact your system/event administrator
  "post bookmark success": "书签已标记",

  mobile: {
    event_list: '我的会议',
    pass_card: '通行证',
    my_home: '个人中心',
    my_sport: '运动',
    session_list: '会议列表',
    refresh: '刷新二维码',
    logout: '退出登录',
    pass_in_min: '该会议在{time}开始进场',
    permission_err: '您暂时没有参加现场会议的权限',
    expire_time: "该二维码有效期<br/>【{time}】<br/>请截图备用",
    lead_time_tips: '该会议在 {time} 开始入场',
  },
  sport: {
    not_begin: '活动即将开始',
    sort_order: '排列顺序',
    sort_asc: '升序排序',
    sort_desc: '降序排序',
    image: '图片',
    video: '视频',
    chosen: '已选择',
    cancelChoose: '取消选择',
    batchDownload: '批量下载',
    sportScore: '项目评价',
    event_organize_well: '活动组织很好',
    event_content_well: '活动内容很好',
    environment_well: '环境很好',
    place_well: '场地很好',
    input_tip1: '您的评价会让我们变得更好',
    commit: '提交',
    no_more: '没有更多了~',
    register_progress: '报名进度',
    item_introduce: '项目介绍',
    tips: '温馨提示',
    had_register: '已报名',
    in_progress: '进行中',
    ended: '已结束',
    stop_register: '停止报名',
    wonderful_moment: '精彩瞬间',
    over_max: '已满员',
    register_now: '立即报名',
    tip2: '注*：如需取消报名，请至项目列表-我的项目中取消',
    register: '报名',
    cancel_identify: '确认取消报名？',
    gotoDetail: '进入详情',
    switch_sport: '切换为最近运动',
    switch_session: '切换为最近会议',
    start_soon: '即将开始',
    had_start: '已开始',
  },
  fold: '收起',
  unfold: '展开',
  man: '男',
  women: '女',
  cancel: '取消',
  commit: '提交',
  assets:{
    division: "分类",
    omd: "上市日期",
    suggest_price: "建议零售价",
    category: "品类",
    page_acc: "图册页码",
    page_kids: "儿童图册页码",
  },
  new_user_helper:{
    main_page:"1.首页广场配有运动赛事，公告；\n" + "2.活动列表；\n" + "3.个人中心入口;\n" + "4.eMoment小助手入口。\n",
    event_detail:"1.活动广场配有运动赛事，预热资产，公告以及VSS；\n" + "2.会议列表包括8种会议类型；\n" + "3.产品资讯库入口。（活动管理员根据活动需要配备对应功能及会议）\n",
    vss_search:"1.新手引导教程；\n" + "2.VSS搜索界面，点击搜索结果，跳转对应视频页面；\n" + "3.继续搜索或观看视频。\n",
    attend_session:"1.会议应用模块（VSS，聊天室，书签，产品推送查等）\n" + "2.视频基础功能（字幕，书签，清晰度，音量等）\n",
    pal:"1.产品资讯库和成套搭配入口；\n" + "2.产品笔记，收藏，历史记录；\n" + "3.筛选搜索区；\n" + "4.产品列表区；\n" + "5.成套展示列表区。\n",
    product_detail:"1.产品详情 - 视频；\n" + "2.产品详情 - 图片；\n" + "3.产品色号列表；\n" + "4.产品收藏，添加收藏夹，笔记。\n"
  },
  relatedSession:"相关会议",
  relatedProduct:"精选推荐",
  more_detail:"更多详情 >",
  ipad_notice:"如果您使用的ipad打开不了产品资讯库，可尝试在“设置—safari浏览器-通用”中关闭“阻止弹出式窗口”选项解决。",
  ipad_notice_title:"ipad使用产品资讯库提醒"
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn.js